'use client';

import React from 'react';
import { AlertTriangle, XCircle, TrendingDown, DollarSign, ExternalLink } from 'lucide-react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';


const alerts = [
  {
    id: 'alert-1',
    severity: 'critical',
    icon: XCircle,
    title: 'Publish failed — PetPal Supply IG',
    detail: '"Weekend Flash Sale" — Instagram token expired',
    action: 'Reconnect Page',
    href: '/client-team-management',
  },
  {
    id: 'alert-2',
    severity: 'critical',
    icon: XCircle,
    title: 'Publish failed — Nexus Tech FB',
    detail: '"Q3 Announcement" — Permission denied',
    action: 'Reconnect Page',
    href: '/client-team-management',
  },
  {
    id: 'alert-3',
    severity: 'warning',
    icon: TrendingDown,
    title: 'CTR below threshold — UrbanWear Co.',
    detail: '"Summer Sale" CTR: 0.61% (target: 0.8%)',
    action: 'Review Campaign',
    href: '/ad-campaign-management',
  },
  {
    id: 'alert-4',
    severity: 'warning',
    icon: DollarSign,
    title: 'Budget 90% consumed — Nexus Tech',
    detail: '"Q3 Launch" $7,650 of $8,500 spent',
    action: 'Adjust Budget',
    href: '/ad-campaign-management',
  },
  {
    id: 'alert-5',
    severity: 'info',
    icon: AlertTriangle,
    title: 'ROAS below target — UrbanWear Co.',
    detail: '"Summer Sale" ROAS: 1.6× (target: 3.0×)',
    action: 'Optimize',
    href: '/ad-campaign-management',
  },
];

const severityStyle: Record<string, string> = {
  critical: 'border-l-negative bg-negative/[0.03]',
  warning: 'border-l-warning bg-warning/[0.03]',
  info: 'border-l-info bg-info/[0.03]',
};

const iconColor: Record<string, string> = {
  critical: 'text-negative',
  warning: 'text-warning',
  info: 'text-info',
};

export default function AlertsPanel() {
  return (
    <div className="card-base p-6 h-full flex flex-col">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-base font-semibold text-foreground">Alerts</h3>
          <p className="text-xs text-muted-foreground mt-0.5">{alerts.length} items need attention</p>
        </div>
      </div>
      <ul className="space-y-2 flex-1">
        {alerts.map((a) => {
          const Icon = a.icon;
          return (
            <li
              key={a.id}
              className={`border-l-2 px-3 py-2.5 rounded-r-lg ${severityStyle[a.severity]}`}
            >
              <div className="flex items-start gap-2">
                <Icon size={13} className={`mt-0.5 shrink-0 ${iconColor[a.severity]}`} />
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-semibold text-foreground leading-tight">{a.title}</p>
                  <p className="text-[11px] text-muted-foreground mt-0.5 truncate">{a.detail}</p>
                </div>
                <Link
                  href={a.href}
                  className="flex items-center gap-0.5 text-[10px] font-medium text-primary hover:underline shrink-0 mt-0.5"
                >
                  {a.action}
                  <ExternalLink size={9} />
                </Link>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}